import { render } from "./ChangeObjectForm.vue?vue&type=template&id=558617ed"
import script from "./ChangeObjectForm.vue?vue&type=script&lang=js"
export * from "./ChangeObjectForm.vue?vue&type=script&lang=js"

import "./ChangeObjectForm.vue?vue&type=style&index=0&id=558617ed&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__